export default __webpack_public_path__ + "static/media/not-found.5c8c2e34.png";